export const CUSTOMERS_CONTACTS = "CUSTOMERS_CONTACTS";
export const IS_NEW_USER = "IS_NEW_USER";
export const SHOW_IJ_FLOW = "SHOW_IJ_FLOW";
export const SHOW_WALK_THROUGH = "SHOW_WALK_THROUGH";
export const PAYMENT_PENDING_MODAL = "PPM";

export const APP_PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.citymall.app&hl=en_US";
export const ACCOUNT_SUSPENDED_DATA_VALUE_KEY = "ACCOUNT_SUSPENDED";

export { default as LEADER_STATES } from "@screens/Home/ClPaymentAndAddress";

export const IS_DEVICE_VERIFIED = {
  ACCEPTED: "ACCEPTED",
  REJECTED: "REJECTED",
  PENDING: "PENDING",
};

export const DeleteBankAc = {
  Delete1: "Delete",
  Cancel: "Cancel",
  primary: "primary",
  white: "white",
  bank_account: "bank_account",
};
